<template>
  <div class="side-menu">
    <el-menu
      :default-active="menuDefaltActive"
      class="pt8 pb8"
      @open="handleOpen"
      @close="handleClose"
      @select="handleSelect">
      
      <template v-for="(item,idx) in menuList">
        <el-submenu v-if="item.child_list != null" :key="idx" :index="String(item.id)">
          <template slot="title">{{item.name}}</template>
          <el-menu-item v-for="(item,idx) in item.child_list" :key="idx" :index="String(item.id)">
            <template slot="title">{{item.name}}</template>
          </el-menu-item>
        </el-submenu>

        <el-menu-item v-else :key="idx" :index="String(item.id)">
          <template slot="title">{{item.name}}</template>
        </el-menu-item>
      </template>
      
    </el-menu>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  components: {
    
  },
  props: {
    
  },
  data: () => ({
  }),
  computed: {
    ...mapState([
      'menuDefaltActive',
      'menuList'
    ])
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        let path = this.$route.path
        if(!['/home', 'detail'].includes(path)) {
          this.$store.commit('SET_MENU_DEFALT_ACTIVE', '')
        }
      }

    }
  },
  methods: {
    handleOpen() {

    },
    handleClose() {

    },
    handleSelect(val) {
      this.$router.push({
        path: '/home',
        query: {
          cat_id: val
        }
      })
    },
  },
  async created() {
    await this.$store.dispatch('GetMenuList')
  },
}
</script>

<style lang="scss" scoped>
.side-menu {
  background: $white;
  min-width: 200px;
}
</style>